import { FormikProps } from "formik";
import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  Divider,
} from "@chakra-ui/react";
import { FormValues } from "@/models/proposalForm.model";
import { MdAccountBalance } from "react-icons/md";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { PixPaymentFields } from "./PixPaymentFields";
import BankPaymentFields from "./BankPaymentField";
import { Proposal } from "@/models/proposal.model";
import { useForm } from "@/contexts/proposalFormContext";


interface BankDataStepProps {
  formik: FormikProps<FormValues["bankData"]>;
  handleBack: () => void;
  proposal?: Proposal | null;
}

export default function BankDataStep({
  formik,
  handleBack,
  proposal,
}: BankDataStepProps) {

  const { formData } = useForm();
  const { personalData } = formData;

  return (
    <Box
      bg="white"
      p={6}
      borderRadius="lg"
      boxShadow="md"
      borderColor="gray.200"
      maxW="800px"
      mx="auto"
    >
      <Flex align="center" mb={4}>
        <Icon as={MdAccountBalance} boxSize={8} color="gray.500" mr={2} />
        <Box>
          <Heading size="md" color="gray.700" fontFamily="Lexend Deca">
            Dados Bancários do seu cliente
          </Heading>
        </Box>
      </Flex>
      <Divider mb={6} />

      <PixPaymentFields formik={formik} proposal={proposal} personalData={personalData} />

      {formik.values.pixType === "BANK_ACCOUNT" && (
        <BankPaymentFields formik={formik} />
      )}

      <Flex justifyContent="flex-end" gap={3} mt={1}>
        <Button
          leftIcon={<Icon as={IoIosArrowBack} />}
          colorScheme="secondary"
          variant="outline"
          onClick={handleBack}
          fontFamily="Lexend Deca"
        >
          Voltar
        </Button>
        <Button
          rightIcon={<Icon as={IoIosArrowForward} />}
          colorScheme="green"
          bg="#51CD80"
          _hover={{ bg: "#48BB78" }}
          onClick={formik.submitForm}
          fontFamily="Lexend Deca"
        >
          Prosseguir
        </Button>
      </Flex>
    </Box>
  );
}
